import { createApp } from 'vue';
import App from './App.vue';
import router from '@/router';
import '@nio-fe/horo-h5/dist/style/components/base-style/index.css';
import 'normalize.css/normalize.css';// 抹平各平台差异
import store from './store/store';
import { NioApmPlus } from "@nio-fe/nio-apm-plus";
import { nativeBridge as nioJsBridge } from '@nio-wad/universal-bridge-h5/dist/nativeBridge';
import baseConfig from "@/config/baseConfig.json";
import {isAlps, currentBrand} from "@/utils/brandUtils";
import HoroUI, { useFontFamily, useDesignToken } from '@nio-fe/horo-h5';
import utils from "@/utils/utils";
import "@nio-fe/horo-icons/lib/style.css";
import "@nio-fe/horo-icons-alps/lib/style.css";
import "@nio-fe/horo-icons-fy/lib/style.css";
import '@/defaultStyle.scss';
import HoroBridge from '@nio-fe/horo-bridge';
import dataTrack from "@/utils/trackUtils";

// import 'babel-polyfill'
// import Es6Promise from 'es6-promise'
// Es6Promise.polyfill()

// 多品牌兼容
const brand = currentBrand();
console.log('main current brand==>',brand);


useDesignToken(brand); // 设置设计token
useFontFamily('cn', brand); // 设置字体
utils.setAppStorage('brand', brand);
// 设置全局brand
window.brand = brand;
document.body.className = `brand-${brand}`;

const app = createApp(App);
app.use(router);
app.use(HoroUI);
app.use(store);
app.use(HoroBridge, {
  components: {
    safeArea: true,
    button: true
  }
})

function insertViewportMeta() {
  let uiScale = 1;
  // const OSInfoRes = nioJsBridge.getOSInfo()
  // if (OSInfoRes?.data?.global_ui_scale &&
  //   OSInfoRes.data.global_ui_scale > 0 &&
  //   OSInfoRes.data.global_ui_scale !== 1) {
  //   uiScale = OSInfoRes.data.global_ui_scale;
  // }
  // console.log('insertViewportMeta ==>',OSInfoRes)
  // nioJsBridge.showToast(OSInfoRes)
  const isIOS = /iPhone/.test(navigator.userAgent) && !window.MSStream;
  if (isIOS) {
    let metaViewport = document.querySelector('meta[name="viewport"]') ;
    if (!metaViewport) {
      metaViewport = document.createElement('meta');
      metaViewport.name = 'viewport';
      document.head.appendChild(metaViewport);
    }
    metaViewport.content = `initial-scale=${uiScale}, maximum-scale=${uiScale}, user-scalable=no`;
  }
}
 if(isAlps()) insertViewportMeta();

// APM
const initApmPlus = () => {
  // 新 APM（参考 https://nio.feishu.cn/wiki/Kd4mwT1AYiDwMskD5jZcNC0pnUf）
  // region 非 cn 时 SDK 不初始化；不传 abTest 且传了 serviceName 时直接使用新 APM
  const apmInstance = NioApmPlus.createDefaultInstanceSync({
    region: 'cn',
    release: '1.0.0',
    serviceEnv: utils.getEnvStr(), // 'dev' | 'test' | 'stg' | 'prod'
    serviceName: 'so-fe-carwash',
    vueErrorHandler: { app }, // vue 项目必传，vue 根 app 对象
    // abTest: true, // 可选，传 true 时按北极星灰度使用新 APM
    plugins: {
      pageview: { routeMode: 'hash' },
      blankScreen: {
        rootSelector: '#app',
        threshold: 1.5,
        screenshot: true,
      },
      vueErrorHandler: { app },
      autoReportClickEvent: { enable: true },
    },
  });
};


// 重试10次调用bridge，探测bridge是否注册成功
async function retryWithBridge(callback, maxRetries = 10, delay = 300) {
  // 本地调试，直接callback
  if (baseConfig.localConfiguration.enableLocalMode) {
    callback();
    return
  }
  // 非本地调试
  let retries = 0;
  function attempt() {
    let userInfo;
    try {
       userInfo = nioJsBridge.getUserInfo();
    }catch(err) {
      console.log('getUserInfo=>',err)
    }
    if (userInfo?.data?.access_token) {
      callback();
    } else if (retries < maxRetries) {
        // 如果调用失败，则进行重试
        retries++;
        // 延迟后进行下一次重试
        setTimeout(attempt, delay);
    } else {
      // 达到最大重试次数，可以添加相应的错误处理逻辑
      console.error("Max retries reached. Bridge method failed.");
    }
  }
  attempt();
}

retryWithBridge(() => {
  app.mount("#app");
  initApmPlus();
});

dataTrack.trackInit()

